import { Grid, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AMProperty } from '../components/AMProperty'
import { theme } from '../utils/theme'
import { AirMotor } from '../utils/types'
import { fetchMotorImage } from '../utils/api'
import { MOTOR_IMAGE_PLACEHOLDER } from '../utils/lib'

type DocumentationType = {
  motor: AirMotor
}

const useStyles = makeStyles(() => ({
  documentation: {
    '& button': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.grey[800],
      },
      '&:disabled': {
        backgroundColor: theme.palette.grey[400],
      },
    },
    '& button:first-of-type': {
      marginTop: theme.spacing(2),
    },
  },
  img: {
    display: 'flex',
    justifyContent: 'center',
    height: '310px',
  },
}))

export const Documentation = ({ motor }: DocumentationType) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [imageUrl, setImageUrl] = useState<string>(MOTOR_IMAGE_PLACEHOLDER)

  useEffect(() => {
    const loadImage = async () => {
      if (motor.productName) {
        const url = await fetchMotorImage(motor.productName)
        setImageUrl(url)
      }
    }
    loadImage()
  }, [motor.productName])

  const onOpenDoc = () => {
    const searchUrl = `https://tools.cp.com/en-us/products/search-result?search=${motor.productName}&isSuggestion=false`
    window.open(searchUrl, '_blank')
  }

  return (
    <Grid container spacing={4} className={classes.documentation}>
      <Grid item md={4} xs={12}>
        <Typography variant="h2">Documentation</Typography>
        <AMProperty label={t('motor.productName')} value={motor.name} />
        <AMProperty label={t('motor.productNumber')} value={motor.productName} />
        {/* <AMProperty label="Product number CP (debug)" value={motor.productNameCP} /> */}
        <Button
          variant="contained"
          onClick={onOpenDoc}
          fullWidth
        >
          {t('details.dimensionalDrawing')}
        </Button>
        <Button
          variant="contained"
          onClick={onOpenDoc}
          fullWidth
        >
          {t('details.3DDrawing')}
        </Button>
      </Grid>
      <Grid item md={8} xs={12} className={classes.img}>
        <img
          src={imageUrl}
          alt="Motor img"
          onError={() => setImageUrl(MOTOR_IMAGE_PLACEHOLDER)}
        />
      </Grid>
    </Grid>
  )
}
